import { render, staticRenderFns } from "./sheets.vue?vue&type=template&id=473874bc&scoped=true"
import script from "./sheets.vue?vue&type=script&lang=js"
export * from "./sheets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473874bc",
  null
  
)

export default component.exports